import global from "@/locales/de-DE/global";
import error403 from "@/locales/de-DE/errors/403";
import error404 from "@/locales/de-DE/errors/404";
import error500 from "@/locales/de-DE/errors/500";
import error503 from "@/locales/de-DE/errors/503";
import error504 from "@/locales/de-DE/errors/504";
import maintenance from "@/locales/de-DE/auth/maintenance";
import toast from "@/locales/de-DE/toast/toast";
import login from "@/locales/de-DE/auth/login";
import onboarding from "@/locales/de-DE/auth/onboarding";
import loginPageSteps from "@/locales/de-DE/loginPageSteps";
import dashboard from "@/locales/de-DE/dashboard/dashboard";
import account from "@/locales/de-DE/account/account";
import mailbox from "@/locales/de-DE/account/mailbox";
import bankstatement from "@/locales/de-DE/account/bankstatement";
import myApps from "@/locales/de-DE/my-apps/myApps";
import about from "@/locales/de-DE/about/about";
import contactService from "@/locales/de-DE/about/contactService";
import salesPromotions from "@/locales/de-DE/sales/promotions";
import brochures from "@/locales/de-DE/sales/brochures";
import shop from "@/locales/de-DE/shop/data";
import priceList from "@/locales/de-DE/shop/priceList";
import staff from "@/locales/de-DE/dashboard/staff";
import promotions from "@/locales/de-DE/promotions";
import points from "@/locales/de-DE/points";
import trainings from "@/locales/de-DE/trainings/trainings";
import vouchers from "@/locales/de-DE/vouchers/vouchers";
import generateReport from "@/locales/de-DE/generate-report/generateReport";
import widgets from "@/locales/de-DE/widgets/widgets";
import wholesaler from "@/locales/de-DE/wholesaler/wholesaler";
import media from "@/locales/de-DE/media/index";
import onlineVisibility from "@/locales/de-DE/sales/onlineVisibility";
import fuelCalculator from "@/locales/de-DE/sales/fuelCalculator";
import product from "@/locales/de-DE/product/index";
import message from "@/locales/de-DE/message/index";
import commitmentLetter from "@/locales/de-DE/account/commitmentLetter";
import multiplicator from "@/locales/de-DE/multiplicator";
import consents from "@/locales/de-DE/consents/consents";
import investment from "@/locales/de-DE/investment/data";
import publicCountryNotice from "@/locales/de-DE/publicCountryNotice";
import kickback from "@/locales/de-DE/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  publicCountryNotice: publicCountryNotice.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  widgets: widgets.messages,
  wholesaler: wholesaler.messages,
  media: media.messages,
  onlineVisibility: onlineVisibility.messages,
  priceList: priceList.messages,
  fuelCalculator: fuelCalculator.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Produkt-Abbildungen",
    BDriveLinkText: "Link zum PRODUKT-ABBILDUNGEN Portal",
  },
}

export default {
  locale: "de-DE",
  messages,
};
